module.exports = __webpack_public_path__ + "static/media/linkedin.36cbc613.svg";